import { useMemo } from "react";
import { Router, Route, Switch } from "react-router-dom";
import { allRoutes } from "./config";
import { useAuth } from "./providers/AuthProvider";
import { DynamicHelmet } from "./DynamicHelmet";
import { useFeaturesGuard, usePermissionGuard } from "./PermissionGuard";
import { createBrowserHistory } from "history";
import AreYouTalkingWithABrokerDialog from "./components/UI/AreYouTalkingWithABrokerDialog";
import RekycModal from "./components/application/ReKycModal";
import SsnEinModal from "./components/application/SsnEinModal";
import PendingVerificationModal from "./components/modal/PendingVerificationModal";
import { useAppDispatch } from "./store/store";
import { setPendingVerificationModal, useGlobalModalsSlice } from "./store/features/modals.slice";

const history = createBrowserHistory();

export const Routing = () => {
  const { isAuthenticated } = useAuth();
  const { hasFeatureEnabled } = useFeaturesGuard();
  const { hasPermission } = usePermissionGuard();

  const dispatch = useAppDispatch();
  const { isPendingVerificationModalOpen } = useGlobalModalsSlice();

  const routes = useMemo(
    () =>
      allRoutes
        .filter((r) => (isAuthenticated || r.public) && hasPermission(r.permissions))
        .filter((r) => hasFeatureEnabled(r.featurePermission))
        .map((r) => (
          <Route key={`${r.title}: ${r.path}`} path={r.path} component={r.component} exact />
        )),
    [isAuthenticated, hasPermission],
  );

  return (
    <Router history={history}>
      <DynamicHelmet>
        <Switch>{routes}</Switch>
        <AreYouTalkingWithABrokerDialog />
        <PendingVerificationModal
          open={isPendingVerificationModalOpen}
          onClose={() => dispatch(setPendingVerificationModal(false))}
        />
        <RekycModal />
        <SsnEinModal />
      </DynamicHelmet>
    </Router>
  );
};
